import { withViewerScope, type ViewerScopedQueryOptions } from "@/lib/viewer-scoped-query";
import { orpc } from "@/utils/orpc.client";

export function getArtistFollowStatusQueryOptions(
  artistId: string,
  options: ViewerScopedQueryOptions = {},
) {
  const queryOptions = orpc.artistFollows.isFollowed.queryOptions({
    input: { artistId },
    enabled: options.enabled,
  });

  return withViewerScope(queryOptions, options.viewerId);
}
